"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnalysisEngine = AnalysisEngine;
exports.DataRenderContext = exports.AnalysisEngineContext = void 0;
exports.EffectivenessWidget = EffectivenessWidget;
exports.effectiveness = effectiveness;
exports.useUtils = useUtils;

var _react = _interopRequireWildcard(require("react"));

var _lodash = require("lodash");

var _tools = require("./utils/tools");

var _action = _interopRequireWildcard(require("./action"));

var _helper = require("./utils/helper");

var _cascade = _interopRequireDefault(require("./cascade"));

var _excluded = ["widget", "children", "dataBind", "name", "_data"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var root = {};

if (typeof window !== 'undefined') {
  root = window;
}

;

function effectiveness(data) {
  if ((0, _tools.isObject)(data) && (typeof data.widget === 'string' || Array.isArray(data.childrens))) {
    return true;
  }

  return false;
}

if (!root._crengine_analys_context) {
  root._crengine_analys_context = /*#__PURE__*/(0, _react.createContext)({
    inEngine: false,
    actions: _action.default,
    globleData: {},
    cascaderList: [],
    formData: {},
    nameMap: {},
    moment: {
      current: false
    },
    formMoment: {
      current: false
    }
  });
}

if (!root._crengine_datarender_context) {
  root._crengine_datarender_context = /*#__PURE__*/(0, _react.createContext)({});
}

var AnalysisEngineContext = root._crengine_analys_context;
exports.AnalysisEngineContext = AnalysisEngineContext;
var DataRenderContext = root._crengine_datarender_context;
exports.DataRenderContext = DataRenderContext;

function useUtils() {
  var _useContext = (0, _react.useContext)(DataRenderContext),
      dataProxy = _useContext.dataProxy,
      defaultData = _useContext.defaultData,
      parentDataBinds = _useContext.parentDataBinds;

  var _useContext2 = (0, _react.useContext)(AnalysisEngineContext),
      formData = _useContext2.formData,
      nameMap = _useContext2.nameMap,
      options = _useContext2.options,
      globleData = _useContext2.globleData,
      runCascade = _useContext2.runCascade,
      inEngine = _useContext2.inEngine;

  var getDataProxy = function getDataProxy() {
    return dataProxy;
  };

  var getFormData = function getFormData() {
    return formData;
  };

  var getDefaultData = function getDefaultData() {
    return defaultData;
  };

  var getOptions = function getOptions() {
    return options;
  };

  var getNameMap = function getNameMap() {
    return nameMap;
  };

  var getParentDataBinds = function getParentDataBinds() {
    return parentDataBinds;
  };

  var getGlobleData = function getGlobleData() {
    return globleData;
  };

  return {
    getDataProxy: getDataProxy,
    getFormData: getFormData,
    getGlobleData: getGlobleData,
    getNameMap: getNameMap,
    getDefaultData: getDefaultData,
    getParentDataBinds: getParentDataBinds,
    getOptions: getOptions,
    inEngine: inEngine,
    runAllCascade: runCascade
  };
} // 组件解析


function ComponentRender(props) {
  var _useContext3 = (0, _react.useContext)(AnalysisEngineContext),
      options = _useContext3.options,
      fieldProps = _useContext3.fieldProps;

  var _ref = options,
      components = _ref.components;

  var widget = props.widget,
      children = props.children,
      dataBind = props.dataBind,
      name = props.name,
      _data = props._data,
      componentProps = _objectWithoutProperties(props, _excluded);

  var Component = (0, _helper.getComponent)(widget, components);

  if (typeof Component === 'undefined') {
    console.error("".concat(widget, " \u4E0D\u5B58\u5728"));
    return children || null;
  }

  return /*#__PURE__*/_react.default.createElement(Component, _extends({}, componentProps, fieldProps), children);
}

function EffectivenessWidget(props) {
  if (Array.isArray(props)) {
    return props.map(function (item, index) {
      if (effectiveness(item)) {
        (0, _tools.addUuidToObj)(item);
        return /*#__PURE__*/_react.default.createElement(ContextBox, {
          key: item.uuid,
          data: item,
          index: index
        });
      }

      return null;
    });
  }

  if (effectiveness(props)) {
    (0, _tools.addUuidToObj)(props);
    return /*#__PURE__*/_react.default.createElement(ContextBox, {
      data: props
    });
  }

  return null;
}

function arrayHasChild(arr) {
  return Array.isArray(arr) && arr.length > 0;
}

var DataRender = /*#__PURE__*/function (_PureComponent) {
  _inherits(DataRender, _PureComponent);

  var _super = _createSuper(DataRender);

  function DataRender(props) {
    var _this;

    _classCallCheck(this, DataRender);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "state", {
      hasError: false
    });

    _defineProperty(_assertThisInitialized(_this), "dataBinds", void 0);

    _defineProperty(_assertThisInitialized(_this), "currentDataBinds", void 0);

    _defineProperty(_assertThisInitialized(_this), "paths", void 0);

    _defineProperty(_assertThisInitialized(_this), "currentPaths", void 0);

    _defineProperty(_assertThisInitialized(_this), "dataProxy", void 0);

    _defineProperty(_assertThisInitialized(_this), "cloneData", void 0);

    _defineProperty(_assertThisInitialized(_this), "firstMount", void 0);

    _defineProperty(_assertThisInitialized(_this), "dataChange", function () {
      var data = _this.props.data;
      var _this$context = _this.context,
          nameMap = _this$context.nameMap,
          cascaderList = _this$context.cascaderList;
      var cascadeOn = data.cascadeOn;

      if (_this.currentPaths.length > 0) {
        (0, _helper.recursionData)({
          nameMap: nameMap,
          dataProxy: _this.dataProxy,
          paths: _this.paths,
          data: data,
          dataClone: (0, _tools.deepCopy)(data)
        });
      }

      if ((0, _tools.isObject)(cascadeOn)) {
        cascaderList.push(_this.bindCascader);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "createUpdataProxy", function (data) {
      if ((0, _tools.isObject)(data)) {
        return new Proxy(data, {
          set: function set(target, prop, value) {
            target[prop] = value;

            _this.forceUpdate();

            return true;
          }
        });
      }

      return data;
    });

    _defineProperty(_assertThisInitialized(_this), "setValue", function (value) {
      if (arrayHasChild(_this.currentDataBinds)) {
        var _formData = _this.context.formData;
        (0, _lodash.set)(_formData, _this.dataBinds, value);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "useActions", function () {
      var _this$context2 = _this.context,
          priActions = _this$context2.actions,
          globleData = _this$context2.globleData,
          formData = _this$context2.formData,
          contextOptions = _this$context2.options,
          nameMap = _this$context2.nameMap,
          update = _this$context2.update;
      var _this$props = _this.props,
          _parent = _this$props._parent,
          _parentIndex = _this$props._parentIndex;
      return function (action, options) {
        return (0, _action._runAction)(action, _objectSpread({
          actions: priActions,
          formData: formData,
          nameMap: nameMap,
          parent: _parent,
          globleData: globleData,
          parentIndex: _parentIndex,
          paths: _this.paths,
          update: update,
          options: contextOptions
        }, options));
      };
    });

    _defineProperty(_assertThisInitialized(_this), "runActions", function (action, options) {
      var runAction = _this.useActions();

      if (Array.isArray(action)) {
        action.reduce( /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(result, currentAction) {
            var currentResult;
            return _regeneratorRuntime().wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    if (!result) {
                      _context.next = 4;
                      break;
                    }

                    _context.next = 3;
                    return result;

                  case 3:
                    result = _context.sent;

                  case 4:
                    _context.next = 6;
                    return runAction(currentAction, _objectSpread({
                      result: result
                    }, options));

                  case 6:
                    currentResult = _context.sent;
                    return _context.abrupt("return", currentResult);

                  case 8:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x, _x2) {
            return _ref2.apply(this, arguments);
          };
        }(), undefined);
      } else {
        return runAction(action, options);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "bindCascader", function () {
      var _this$props2 = _this.props,
          data = _this$props2.data,
          _parentName = _this$props2._parentName;
      var cascadeOn = data.cascadeOn;
      var _this$context3 = _this.context,
          formData = _this$context3.formData,
          nameMap = _this$context3.nameMap;
      var options = {
        formData: formData,
        defaultData: _this.cloneData,
        dataProxy: _this.dataProxy,
        parentDataBinds: _parentName,
        nameMap: nameMap
      };
      (0, _cascade.default)(cascadeOn, options);
    });

    _defineProperty(_assertThisInitialized(_this), "setDataValue", function (formData) {
      if (arrayHasChild(_this.currentDataBinds)) {
        var _data3 = _this.props.data;
        _data3.value = (0, _lodash.get)(formData, _this.dataBinds);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (value, options) {
      var _this$context4 = _this.context,
          runCascade = _this$context4.runCascade,
          events = _this$context4.events,
          formData = _this$context4.formData; // 暂时兼容目前的组件传值方式 // 需改成value形式

      if ((value === null || value === void 0 ? void 0 : value.value) !== undefined) {
        _this.dataProxy.value = value === null || value === void 0 ? void 0 : value.value;

        _this.setValue(value === null || value === void 0 ? void 0 : value.value);
      } else {
        _this.dataProxy.value = value;

        _this.setValue(value);
      }

      runCascade();

      if ((0, _tools.isObject)(events) && typeof events.onChange === 'function') {
        events.onChange(value, _objectSpread(_objectSpread({}, options), {}, {
          formData: formData,
          targetData: _this.dataProxy
        }));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSubmit", function (e, options) {
      var _this$context5 = _this.context,
          events = _this$context5.events,
          formData = _this$context5.formData;
      var data = _this.props.data;
      var action = data.action,
          preValidate = data.preValidate; // 如果前置验证，验证成功后执行action，否则直接执行

      if ((0, _tools.isObject)(preValidate)) {
        _this.runActions({
          type: 'pre-validate',
          data: preValidate
        }).then(function () {
          _this.runActions(action, options);

          (0, _tools.isFunction)(events === null || events === void 0 ? void 0 : events.onSubmit) && events.onSubmit(e, {
            formData: formData,
            targetData: _this.dataProxy
          });
        });
      } else {
        _this.runActions(action, options);

        (0, _tools.isFunction)(events === null || events === void 0 ? void 0 : events.onSubmit) && events.onSubmit(e, {
          formData: formData,
          targetData: _this.dataProxy
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onClick", function (e, options) {
      var _this$context6 = _this.context,
          events = _this$context6.events,
          formData = _this$context6.formData;
      var data = _this.props.data;
      var action = data.action,
          preValidate = data.preValidate; // 如果前置验证，验证成功后执行action，否则直接执行

      if ((0, _tools.isObject)(preValidate)) {
        _this.runActions({
          type: 'pre-validate',
          data: preValidate
        }).then(function () {
          _this.runActions(action, options);

          (0, _tools.isFunction)(events === null || events === void 0 ? void 0 : events.onClick) && events.onClick(e, {
            formData: formData,
            targetData: _this.dataProxy
          });
        });
      } else {
        _this.runActions(action, options);

        (0, _tools.isFunction)(events === null || events === void 0 ? void 0 : events.onClick) && events.onClick(e, {
          formData: formData,
          targetData: _this.dataProxy
        });
      }
    });

    var _data2 = props.data,
        _parent2 = props._parent,
        _parentName2 = props._parentName,
        _parentPath = props._parentPath;

    var proxyData = _objectSpread(_objectSpread({}, _data2), {}, {
      _parent: _parent2
    });

    var names = (0, _helper.getPath)(_data2);
    var nextNames = [].concat(_parentName2, names).filter(function (item) {
      return ['string', 'number'].indexOf(_typeof(item)) >= 0;
    });
    var paths = (0, _helper.resolvePath)(_data2 === null || _data2 === void 0 ? void 0 : _data2.name);
    var nextPaths = [].concat(_parentPath, paths).filter(function (item) {
      return ['string', 'number'].indexOf(_typeof(item)) >= 0;
    });
    proxyData.wprops = _this.createUpdataProxy(proxyData.wprops);
    _this.currentDataBinds = names;
    _this.dataBinds = nextNames;
    _this.currentPaths = paths;
    _this.paths = nextPaths;
    _this.cloneData = (0, _lodash.cloneDeep)(_data2);
    _this.dataProxy = new Proxy(proxyData, {
      set: function set(target, prop, value) {
        _data2[prop] = value;

        if (prop === 'wprops') {
          target[prop] = _this.createUpdataProxy(value);
        } else {
          target[prop] = value;
        }

        _this.forceUpdate();

        return true;
      }
    });
    return _this;
  }

  _createClass(DataRender, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      // 后期做错误信息上报
      console.error(error);
      console.error(errorInfo);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this2 = this;

      var data = this.props.data;
      var cascadeOn = data.cascadeOn;
      var cascaderList = this.context.cascaderList;

      if ((0, _tools.isObject)(cascadeOn)) {
        var index = cascaderList.findIndex(function (item) {
          return item === _this2.bindCascader;
        });
        cascaderList.splice(index, 1);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          data = _this$props3.data,
          index = _this$props3.index,
          _parentName = _this$props3._parentName;
      var _this$context7 = this.context,
          events = _this$context7.events,
          moment = _this$context7.moment,
          formMoment = _this$context7.formMoment;
      var hasError = this.state.hasError;
      var hidden = data.hidden,
          widget = data.widget,
          wprops = data.wprops,
          childrens = data.childrens;

      if (hidden) {
        return null;
      }

      if (hasError) {
        /*#__PURE__*/
        _react.default.createElement("div", null, "error\uFF1A\u7EC4\u4EF6\u6E32\u67D3\u9519\u8BEF");
      }

      if ((0, _tools.isObject)(formMoment.current)) {
        this.setDataValue(formMoment.current);
      }

      if (!moment.current) {
        this.setValue((0, _helper.getValue)(data));
        this.dataChange();
      }

      return /*#__PURE__*/_react.default.createElement(DataRenderContext.Provider, {
        value: {
          dataProxy: this.dataProxy,
          dataBinds: this.dataBinds,
          defaultData: this.cloneData,
          parentDataBinds: _parentName,
          paths: this.paths,
          index: index
        }
      }, /*#__PURE__*/_react.default.createElement(ComponentRender, _extends({
        value: data.value,
        defaultValue: data.defaultValue,
        name: data.name,
        names: arrayHasChild(this.currentDataBinds) ? this.dataBinds : undefined,
        paths: arrayHasChild(this.currentPaths) ? this.paths : undefined,
        dataBind: data.dataBind,
        widget: widget
      }, wprops, events, {
        onClick: this.onClick,
        onChange: this.onChange,
        onSubmit: this.onSubmit,
        _data: this.dataProxy
      }), EffectivenessWidget(childrens)));
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        hasError: true
      };
    }
  }]);

  return DataRender;
}(_react.PureComponent);

_defineProperty(DataRender, "contextType", AnalysisEngineContext);

_defineProperty(DataRender, "defaultProps", {
  index: undefined
});

function ContextBox(props) {
  return /*#__PURE__*/_react.default.createElement(DataRenderContext.Consumer, null, function (_ref3) {
    var dataBinds = _ref3.dataBinds,
        paths = _ref3.paths,
        dataProxy = _ref3.dataProxy,
        index = _ref3.index;
    return /*#__PURE__*/_react.default.createElement(DataRender, _extends({}, props, {
      _parent: dataProxy,
      _parentIndex: index,
      _parentPath: paths,
      _parentName: dataBinds
    }));
  });
}
/**
 * 引擎渲染
 * @param {object}     data         数据
 * @param {object}     options      参数
 * @param  {object}    events       回调事件
 * @param  {array}     path         name路径
 * @param  {object}    lifecycle    生命周期
 */


function AnalysisEngine(props) {
  var _options;

  var dataSource = props.dataSource,
      _props$globleData = props.globleData,
      globleData = _props$globleData === void 0 ? {} : _props$globleData,
      _props$embed = props.embed,
      embed = _props$embed === void 0 ? false : _props$embed,
      children = props.children,
      lifeCycle = props.lifeCycle,
      engineRef = props.engineRef;
  var ParentText = (0, _react.useContext)(DataRenderContext);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setUpdate = _useState2[1];

  var moment = (0, _react.useRef)(false);
  var formMoment = (0, _react.useRef)(false);
  var fieldProps = props.fieldProps;

  var update = function update() {
    moment.current = false;
    setUpdate(!state);
  };

  var _runEffectivenessProp = (0, _tools.runEffectivenessProps)(props),
      options = _runEffectivenessProp.options,
      nameMap = _runEffectivenessProp.nameMap,
      formData = _runEffectivenessProp.formData,
      cascaderList = _runEffectivenessProp.cascaderList,
      events = _runEffectivenessProp.events;

  var runCascade = function runCascade() {
    cascaderList.forEach(function (func) {
      typeof func === 'function' && func();
    });
  };

  var parentData = (0, _react.useContext)(AnalysisEngineContext);

  var setFormData = function setFormData(data) {
    formMoment.current = data;
    setUpdate(!state);
  };

  if (engineRef && (0, _tools.isObject)(engineRef)) {
    engineRef.current = {
      setFormData: setFormData
    };
  }

  if ((0, _tools.isFunction)(lifeCycle === null || lifeCycle === void 0 ? void 0 : lifeCycle.willRender)) {
    var _lifeCycle$willRender;

    lifeCycle === null || lifeCycle === void 0 ? void 0 : (_lifeCycle$willRender = lifeCycle.willRender) === null || _lifeCycle$willRender === void 0 ? void 0 : _lifeCycle$willRender.call(lifeCycle, {
      formData: formData,
      nameMap: nameMap,
      cascaderList: cascaderList
    });
  }

  moment.current = false;
  (0, _react.useEffect)(function () {
    moment.current = true;
    formMoment.current = false;
    runCascade();

    if (lifeCycle && (0, _tools.isFunction)(lifeCycle === null || lifeCycle === void 0 ? void 0 : lifeCycle.afterRender)) {
      var _lifeCycle$afterRende;

      (_lifeCycle$afterRende = lifeCycle.afterRender) === null || _lifeCycle$afterRende === void 0 ? void 0 : _lifeCycle$afterRende.call(lifeCycle, {
        formData: formData,
        nameMap: nameMap,
        cascaderList: cascaderList
      });
    }
  }); // 需要劫持组件内调用的AnalysisEngine时加propItemRender

  if (parentData.propItemRender && (0, _tools.isFunction)(parentData.propItemRender)) {
    return parentData.propItemRender(dataSource);
  } // 内嵌模式


  if (embed) {
    if ((0, _tools.isObject)(parentData)) {
      nameMap = parentData.nameMap;
      formData = parentData.formData;
      cascaderList = parentData.cascaderList;
      fieldProps = parentData.fieldProps;

      if (parentData.update) {
        update = parentData.update;
      } // 如果内嵌模式需要自定义options，合并父子options


      options = (0, _helper.assignObj)(options, parentData.options); // 如果内嵌模式需要自定义events，合并父子events

      events = (0, _helper.assignObj)(events, parentData.events);
    } else {
      console.error('内嵌组件必须包含在非内嵌组件内');
    }
  } // components undefined


  if (!(0, _tools.isObject)(options) && !embed) {
    console.error('options为必填项');
    return null;
  }

  if (!(0, _tools.isObject)((_options = options) === null || _options === void 0 ? void 0 : _options.components)) {
    console.error('options.components为必填项');
    return null;
  }

  return /*#__PURE__*/_react.default.createElement(AnalysisEngineContext.Provider, {
    value: {
      dataSource: dataSource,
      formData: formData,
      options: options,
      events: events,
      inEngine: true,
      actions: _objectSpread(_objectSpread({}, _action.default), options.actions),
      cascaderList: cascaderList,
      runCascade: runCascade,
      nameMap: nameMap,
      globleData: globleData,
      update: update,
      fieldProps: fieldProps,
      moment: moment,
      formMoment: formMoment
    }
  }, /*#__PURE__*/_react.default.createElement(DataRenderContext.Provider, {
    value: ParentText
  }, EffectivenessWidget(dataSource), children));
}